import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/icons/arrow-left-eoi-request.svg'
import _imports_1 from '@/assets/images/zepto.svg'


const _hoisted_1 = { class: "layout-eoi" }
const _hoisted_2 = {
  key: 0,
  class: "wrapper flex container"
}
const _hoisted_3 = { class: "form-box" }
const _hoisted_4 = {
  key: 0,
  class: "short-info"
}
const _hoisted_5 = { class: "short-info-list" }
const _hoisted_6 = { class: "short-info-list-header" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "basic-info" }
const _hoisted_9 = { class: "basic-info" }
const _hoisted_10 = { class: "basic-info" }
const _hoisted_11 = { class: "basic-info" }
const _hoisted_12 = { class: "total" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = {
  key: 0,
  class: "total-value"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 2,
  class: "spiner-wr"
}
const _hoisted_17 = { class: "card-box" }
const _hoisted_18 = { class: "sticky" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["HeaderCustomer"], {
      estate: $setup.estate,
      businessId: $setup.businessId,
      hideAuthButtons: !$setup.isLogged()
    }, null, 8, ["estate", "businessId", "hideAuthButtons"]),
    _createElementVNode("div", { class: "link-back container" }, [
      _createElementVNode("a", {
        class: "back",
        onClick: $setup.onBack
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "EOI Request"
        }, null, -1),
        _createTextVNode("Contract Information Form", -1)
      ]))])
    ]),
    ($setup.estate._id)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode($setup["EOIInfoMessage"], {
              "is-refundable": $setup.estate.isRefundable,
              deposit: $setup.estate?.initDeposit
            }, null, 8, ["is-refundable", "deposit"]),
            _createElementVNode("form", {
              class: "eoi-form",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "section-title" }, "Deposit payment", -1)),
              ($setup.store.state.eoi.eoiObj?._id === $setup.eoiId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h3", _hoisted_7, _toDisplayString($setup.eoiInfo.buyersData.firstBuyer.firstName) + " " + _toDisplayString($setup.eoiInfo.buyersData.firstBuyer.middleName) + " " + _toDisplayString($setup.eoiInfo.buyersData.firstBuyer.lastName), 1),
                        _createVNode(_component_router_link, {
                          class: "short-info-change",
                          to: `/estate/${$setup.estateId}/lot/${$setup.lotId}/eoi-request?eoiId=${$setup.eoiId}`
                        }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createTextVNode("Change", -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _createElementVNode("p", _hoisted_8, _toDisplayString($setup.eoiInfo.buyersData.firstBuyer.email), 1),
                      _createElementVNode("p", _hoisted_9, _toDisplayString($setup.eoiInfo.buyersData.firstBuyer.address) + "," + _toDisplayString($setup.eoiInfo.buyersData.firstBuyer.postcode
? $setup.eoiInfo.buyersData.firstBuyer.postcode
: $setup.eoiInfo.buyersData.firstBuyer.state), 1),
                      _createElementVNode("p", _hoisted_10, _toDisplayString($setup.eoiInfo?.conveyancerDetails?.firmName || "-"), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString($setup.eoiInfo?.buyerType || "-"), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "total-caption" }, "Initial deposit amount:", -1)),
                  ($setup.lot)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString($setup.formatStripePrice($setup.estate?.initDeposit)), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode($setup["CheckboxInput"], {
                class: "agree-checkbox",
                modelValue: $setup.isAgree,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isAgree) = $event)),
                label: "I have read and understand the refund conditions outlined above"
              }, null, 8, ["modelValue"]),
              (!$setup.loading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button proceed",
                    onClick: $setup.pay,
                    disabled: !$setup.isAgree
                  }, "Pay With Zepto", 8, _hoisted_15))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "spinner spinner-small" }, null, -1)
                  ]))])),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "zepto-info" }, [
                _createElementVNode("img", {
                  class: "zepto-logo",
                  src: _imports_1
                }),
                _createElementVNode("p", { class: "zepto-description" }, "Zepto is a free and secure payment method. You can make your deposit payment online using your internet banking. The transaction will be created as a one-time (single payment) direct-debit authorisation. No payment fees apply.")
              ], -1))
            ], 32)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createVNode($setup["LotCard"], {
                lot: $setup.lot,
                estate: $setup.estate
              }, null, 8, ["lot", "estate"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode($setup["AttentionModal"], {
      isOpen: $setup.showAttentionModal,
      title: "Attention",
      description: "Payments are temporarily unavailable. Please try again later.",
      onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.showAttentionModal = false))
    }, null, 8, ["isOpen"])
  ]))
}